import { Paper, Group, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'

export function AlertBanner({ children, color = 'orange' }) {
  return (
    <Paper
      p="xs"
      px="md"
      style={{
        background: `rgba(255, 145, 0, 0.1)`,
        border: `1px solid rgba(255, 145, 0, 0.3)`,
        borderRadius: 'var(--mantine-radius-sm)',
      }}
    >
      <Group gap="xs" wrap="nowrap">
        <IconAlertTriangle size={16} color="var(--mantine-color-orange-4)" style={{ flexShrink: 0 }} />
        <Text size="xs" c="orange.3" fw={600} ff="Orbitron, sans-serif">
          {children}
        </Text>
      </Group>
    </Paper>
  )
}
